import "./serviceDevelopment.css"
import {Divider} from "../components/Divider/Divider";
import {Object} from "./components/object/Object";

export function ServiceDevelopment(){

  return (
    <div>
      <div className="welcomePage__Header">
        Развитие сервиса
      </div>

      <Divider configuration={'small'} />

      <div className="whyConsumerNeed__TextBlock">
        <div className="whyConsumerNeed__TextBlock__ObjectCircle">

          <div className="whyConsumerNeed__TextBlock__ObjectCircle__BlackCircle">
            <svg width="84" height="84" viewBox="0 0 84 84" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M0 41.6771C0 18.6615 18.6615 0 41.6823 0C64.6979 0 83.3594 18.6615 83.3594 41.6771C83.3594 64.6979 64.6979 83.3594 41.6823 83.3594C18.6615 83.3594 0 64.6979 0 41.6771Z" fill="#232422"/>
            </svg>
          </div>






          <div className="whyConsumerNeed__TextBlock__ObjectCircle__Text">
            <svg width="44" height="42" viewBox="0 0 44 42" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M25.5676 0.452981C24.3957 0.291523 23.3124 1.10923 23.1509 2.28631C22.9946 3.45819 23.8176 4.53631 24.9894 4.69777C25.0051 4.69777 25.0259 4.69777 25.0415 4.70298C34.0884 5.81236 40.5103 14.0259 39.3957 23.0415C38.2759 32.0571 30.0415 38.4634 20.9999 37.3488C11.953 36.2394 5.52589 28.0259 6.64568 19.0103C7.19777 14.5363 9.56756 10.4842 13.2082 7.80194L12.203 16.3905C12.0676 17.5676 12.9061 18.6301 14.0884 18.7655C15.2655 18.9061 16.3332 18.0676 16.4738 16.8905L17.9634 4.13006C18.104 2.95298 17.2603 1.88527 16.0832 1.74986H16.078L3.27589 0.255065C2.09881 0.119649 1.0311 0.958189 0.895684 2.13527C0.755059 3.30715 1.59881 4.36965 2.77589 4.51027L9.47381 5.29152C0.781101 12.7394 -0.213692 25.8019 7.26027 34.4686C14.729 43.1405 27.8332 44.1301 36.5311 36.6821C45.2238 29.2342 46.2186 16.1665 38.7446 7.49986C35.3853 3.60402 30.6874 1.0884 25.5676 0.452981Z" fill="#EFF0EF"/>
            </svg>
          </div>

        </div>
        <div className="whyConsumerNeed__TextBlock__BodyText">
          При достаточном научно-техническом сопровождении для завода возможно снижение количества контрольных образцов. Для потребителя возможно увеличение эксплуатационных характеристик материала, что снизит материалоемкость строительства.
        </div>
      </div>

      <div className="serviceDevelopment__Diagram  element-animation">

        <div className="serviceDevelopment__Diagram__Center">
          <div className="serviceDevelopment__Diagram__Center__Circle">
            <div className="serviceDevelopment__Diagram__BlueCircle">
              <div className="serviceDevelopment__Diagram__BlueCircle__Text">
                StatBIM
              </div>
            </div>
          </div>
          <div className="serviceDevelopment__Diagram__BlueCircle__arrows">
            <svg width="544" height="545" viewBox="0 0 544 545" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMin meet" >
              <path fill-rule="evenodd" clip-rule="evenodd" d="M243.01 0.71875C241.854 0.71875 240.693 0.994792 239.661 1.59896C237.474 2.83333 236.115 5.17708 236.219 7.69271V13.2813C181.359 20.7083 128.38 45.2344 86.2239 87.4063C41.25 132.37 16.0208 189.646 10.5624 248.411C10.3124 251.583 12.3229 254.505 15.3645 255.411C20.0468 256.818 24.776 253.297 24.75 248.411C30.1822 193.271 53.9791 139.594 96.2083 97.349C135.604 57.9479 184.979 34.7865 236.219 27.4323V29.3958C236.245 31.4375 237.198 33.349 238.859 34.5313C240.922 36.0208 243.641 36.1927 245.854 34.9583L266.526 24.6875C269.422 23.3021 271.083 20.1823 270.552 17.0365C270.375 15.8542 269.849 14.7708 269.12 13.8646C268.391 12.9323 267.484 12.1771 266.375 11.724L246.328 1.65104C245.297 1.04688 244.167 0.744791 243.01 0.71875ZM298.297 12C294.927 12.1771 292.161 14.7448 291.755 18.1198C291.229 22.1719 294.224 25.849 298.297 26.1719C352.656 32.0156 405.479 55.6823 447.135 97.349C486.698 136.927 509.865 186.578 517.109 238.016H514.443C512.406 238.036 510.521 239.021 509.339 240.682C507.828 242.719 507.677 245.438 508.911 247.656L519.198 268.401C520.583 271.271 523.677 272.932 526.818 272.406C528 272.229 529.109 271.677 530.016 270.943C530.943 270.214 531.698 269.307 532.151 268.198L542.214 248.135C543.422 246.094 543.422 243.552 542.24 241.464C541.005 239.297 538.693 237.938 536.177 238.016H531.323C523.979 182.953 499.375 129.729 457.068 87.4063C412.646 42.9688 356.276 17.8906 298.297 12ZM16.7239 275.802C15.5416 276.005 14.4114 276.531 13.5052 277.266C12.5729 277.995 11.8697 278.901 11.3906 280.01L1.30724 300.073C0.0989036 302.115 0.0989033 304.656 1.2812 306.745C2.51557 308.938 4.85411 310.271 7.36974 310.193H12.3489C20.1197 364.349 44.5729 416.594 86.2239 458.26C131.276 503.302 188.651 528.531 247.484 533.943C251.109 533.995 254.177 531.224 254.505 527.599C254.859 523.443 251.635 519.87 247.484 519.818C192.271 514.458 138.495 490.641 96.2083 448.344C57.2708 409.417 34.2552 360.75 26.5833 310.193H29.0781C31.1145 310.172 33.026 309.188 34.2291 307.552C35.7135 305.484 35.8645 302.745 34.6093 300.552L24.3697 279.833C22.9895 276.938 19.8697 275.276 16.7239 275.802ZM518.37 299.193C512.583 353.677 488.865 406.599 447.135 448.344C407.818 487.641 358.542 510.755 307.427 518.182V515.563C307.427 513.526 306.474 511.609 304.812 510.401C302.776 508.917 300.031 508.792 297.818 510.026L277.115 520.271C274.224 521.656 272.562 524.755 273.094 527.901C273.271 529.083 273.797 530.214 274.526 531.125C275.255 532.052 276.187 532.786 277.297 533.24L297.339 543.333C299.406 544.542 301.943 544.542 304.031 543.359C306.219 542.125 307.531 539.786 307.427 537.266V532.38C362.161 524.88 414.984 500.333 457.068 458.26C501.542 413.771 526.667 357.276 532.505 299.193C532.328 295.318 529.057 292.318 525.161 292.448C521.49 292.573 518.521 295.516 518.37 299.193Z" fill="#B3B6BA"/>
            </svg>
          </div>

          <div className="serviceDevelopment__Diagram__Center__LeftBlocks__Wrapper">
            <div className="serviceDevelopment__Diagram__Center__LeftBlocks">
              <Object name={'Завод'} />
            </div>
            <div className="serviceDevelopment__Diagram__Center__LeftBlocks__Arrow">
              <div className="serviceDevelopment__Diagram__Center__LeftBlocks__Arrow__arrow">

              </div>
            </div>
          </div>

          <div className="serviceDevelopment__Diagram__Center__BottomBlocks__Wrapper">
            <div className="serviceDevelopment__Diagram__Center__BottomBlocks">
              <Object name={'Проектировщик'} />
              <div className="serviceDevelopment__Diagram__Center__BottomBlocks__Arrow__left">
                <div className="serviceDevelopment__Diagram__Center__BottomBlocks__Arrow__arrow__left">

                </div>
              </div>

              <div style={{paddingTop: '30px'}}>
                <Object name={'Подрядчик'} />
                <div className="serviceDevelopment__Diagram__Center__BottomBlocks__Arrow__center">
                  <div className="serviceDevelopment__Diagram__Center__BottomBlocks__Arrow__arrow__center">

                  </div>
                </div>
              </div>

              <Object name={'Застройщик'} />
              <div className="serviceDevelopment__Diagram__Center__BottomBlocks__Arrow__right">
                <div className="serviceDevelopment__Diagram__Center__BottomBlocks__Arrow__arrow__right">

                </div>
              </div>
            </div>
          </div>



        </div>



      </div>




    </div>
  )
}
